import { batchMove, cbForMove } from '..';
export const moveService = async (folders, destination, repository, size, configParams) => {
    return await batchMove(folders, cbForMove(destination, repository, configParams), size);
};
